// 予約機能で共通する抽選予約に関する表示部品を定義
// 情報照会、変更内容確認で共有

import React, { ReactNode } from 'react'
import { convertFalsyValueToUnfilled } from '../../../../utils/stringUtil'
import { LabelGItemBase, ValueGItemBase } from '../grids'

// 項目ラベルのGrid item
export const LabelGItem = (props: { children?: ReactNode }) => <LabelGItemBase xs={5}>{props.children}</LabelGItemBase>
// 項目値のGrid item
export const ValueGItem = (props: { children: ReactNode, hideColon?: boolean }) => <ValueGItemBase xs={7} hideColon={props.hideColon}>{props.children}</ValueGItemBase>

// 値が負の場合（undefined, null...)は「未入力」、そうでない場合は値+接尾辞
type convertFalsyValueToUnfilledValueGItemProps = {
    value?: string | null
    suffix?: string
}
export const ConvertFalsyValueToUnfilledValueGItem: React.FC<convertFalsyValueToUnfilledValueGItemProps> = (props) => {
    const { value, suffix } = props
    return (
        <ValueGItem>{convertFalsyValueToUnfilled(value, suffix)}</ValueGItem>
    )
}